export const PrintAction = ({ onPrint, disabled }) => ({
  label: "Print",
  icon: "print",
  onClickBulk: onPrint,
  disabled,
})
